import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";
import axios from "axios";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {doDownloadFile} from "../../utils/DownloadHelper";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class LoansService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpclient = new HttpClient()
    }


    getLoanKinds() {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                "fund-presentation/loan-kinds",
                this.httpclient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    calculateLoan(fundID, userId, loanAmount, loanInstallments, loanKinds, loadPayDate) {
        return new Promise((resolve, reject) => {
            this.httpclient.post(
                `fund-presentation/funds/${fundID}/loans/pre-create`,
                {
                    "depositAccountId": userId,
                    "amount": loanAmount,
                    "numberOfInstallments": loanInstallments,
                    "loanKindId": loanKinds,
                    "grantDate": moment.from(loadPayDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
                },
                this.httpclient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    createLoan(fundID, cashId, loanAmount, loanInstallments, loanKind, loadPayDate, submitPaidForAll) {
        return new Promise((resolve, reject) => {
            this.httpclient.post(
                `fund-presentation/funds/${fundID}/loans`,
                {
                    "depositAccountId": cashId,
                    "amount": loanAmount,
                    "numberOfInstallments": loanInstallments,
                    "loanKindId": loanKind,
                    "grantDate": moment.from(loadPayDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD'),
                    "submitPaidForAll": submitPaidForAll
                },
                this.httpclient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    getLoansList(fundID, page, filters, size = 15) {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                `fund-presentation/funds/${fundID}/loans`,
                this.httpclient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size,
                    ...filters
                }
            ).then(resolve).catch(reject)
        })
    }


    getLoanDetail(fundID, loanId) {
        const loanStatusRequest = this.httpclient.get(
            `fund-presentation/funds/${fundID}/loans/${loanId}/details-status`,
            this.httpclient.prepareUserAccessHeader(this.token)
        );

        const loanDetailRequest = this.httpclient.get(
            `fund-presentation/funds/${fundID}/loans/${loanId}`,
            this.httpclient.prepareUserAccessHeader(this.token)
        )

        const requestList = [loanStatusRequest, loanDetailRequest]

        return new Promise((resolve, reject) => {
            axios.all(requestList)
                .then(axios.spread((loanStatusResponse, loanDetailResponse) => {
                    resolve({
                        loanStatusResponse, loanDetailResponse
                    })
                })).catch(reject)
        })
    }

    deleteLoin(fundID, loinId) {
        return new Promise((resolve, reject) => {
            this.httpclient.delete(
                `fund-presentation/funds/${fundID}/loans/${loinId}?`,
                this.httpclient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    downloadLoanReports(loanId, reportType) {
        this.loading(setLoadingStateDispatch(true))

        this.httpclient.getFile(
            `fund-presentation/funds/${this.fundID}/loans/${loanId}/reports/${reportType.id}`,
            this.httpclient.prepareUserAccessHeader(this.token)
        ).then(response => {

            doDownloadFile(response, `گزارش وضعیت وام ${loanId}`, reportType.type)

            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(
                reason,
                "خطا در دریافت فایل گزارش",
                this.snackbar,
                this.loading
            )
        })
    }

    getReceiptFile(id) {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                `fund-presentation/${this.fundID}/loan-receipts/${id}`,
                this.httpclient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    doUploadFile(id, imageFile, setHideImageUploadLoading, setProgressImage, setBufferImage) {
        return new Promise((resolve, reject) => {
            uploadFile(imageFile, setProgressImage, setBufferImage,
                setHideImageUploadLoading,
                `fund-presentation/${this.fundID}/loans/${id}/loan-receipts`,
                this.token)
                .then(resolve).catch(reject)
        })
    }
}